import ColorPalet from "./colorPalet";

export default ColorPalet;
